import Axios from "axios"

export const search = (params) => {
    return Axios.get('/api/tasks', {params});
}

export const get = (id) => {
    return Axios.get(`/api/tasks/${id}`);
}

export const save = (task) => {
    if (task.id) {
        return Axios.put(`/api/tasks/${task.id}`, task);
    }
    return Axios.post('/api/tasks', task);
}

export const deleteTask = (id) => {
    return Axios.delete(`/api/tasks/${id}`);
}

export const updateStage = (taskId, stage, option, notes) => {
    return Axios.post(`/api/tasks/${taskId}/stages`, {
        stage,
        option,
        notes,
    });
}

export default {
    search,
    get,
    save,
    updateStage,
    deleteTask,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/TaskService.js